import { useEffect, useState } from "react";

const isVisible = () => document.visibilityState !== "hidden";

/** Whether the page's tab is currently visible, updated on `visibilitychange`. */
export const useDocumentVisible = (): boolean => {
  const [visible, setVisible] = useState(isVisible);

  useEffect(() => {
    const onVisibilityChange = () => setVisible(isVisible());
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", onVisibilityChange);
  }, []);

  return visible;
};
